import * as React from "react";
const SvgArrowDrop = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}><path d="m14 20 10 10 10-10z" /></svg>;
export { SvgArrowDrop as ReactComponent };